import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BasePage from "../Index";
import { Route, Switch, withRouter } from "react-router-dom";
import _ from "lodash/fp";
import routes from "../../routes";
import EditSubscription from "../EditSubscription";
import OutsideRedirect from "../OutsideRedirect";
import ErrorBoundary from "../../error";
import { getIsAuth } from "./actions";
import { productNames } from "../../constants/appData";
import { Theme } from "discover.medical.react-component-library";
import appStyles from "./styles.css";
import rclStyles from "discover.medical.react-component-library/lib/index.dmp.css";

export class App extends React.Component {
  renderRoute = (props, route) => {
    if (this.props.isAuth === null) {
      return null;
    }
    if (route.secure === false || this.props.isAuth === true) {
      return (
        <ErrorBoundary team={route.team || null}>
          <BasePage
            productCode={this.props.productCode}
            productName={productNames[this.props.productCode]}
          >
            {this.props.hasRole ? (
              <EditSubscription />
            ) : (
              <route.component
                {...props}
                {...route.props}
                routes={route.routes || null}
              />
            )}
          </BasePage>
        </ErrorBoundary>
      );
    }
    return (
      <OutsideRedirect
        path={
          "/login?&action=register_subscription&returnToUrl=" +
          (typeof window !== "undefined" && window.location.pathname)
        }
      />
    );
  };

  RouteWithSubRoutes = (route) => (
    <Route
      key={_.uniqueId()}
      exact={route.exact || false}
      path={route.path}
      render={(props) => this.renderRoute(props, route)}
    />
  );
  componentDidMount() {
    this.props.getIsAuth();
  }

  render() {
    return (
      <React.Fragment>
        <Theme ui={this.props.productCode}>
          <Switch>
            {routes.map((route) => this.RouteWithSubRoutes(route, this.props))}
          </Switch>
        </Theme>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getIsAuth,
    },
    dispatch,
  );

export const mapStateToProps = ({ auth, productInfo }) => ({
  isAuth: auth.isAuth,
  hasRole: auth.hasRole,
  errors: auth.errors,
  // TODO - this should be removed once we have a proper way to set the product code
  productCode: productInfo.productCode ?? "dmp",
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
